<template>
  <div class="option-list">
    <div
      v-for="(o, i) in opciones"
      :key="`opt_${i}`"
      class="option-row"
      :class="{ 'option-row--active': seleccion === o.PrecioUnitario }"
      @click="choose(o)"
    >
      <div class="option-main">
        <span class="option-label">{{ o.nombre }}</span>
        <span class="option-price">$ {{ o.PrecioUnitario }}</span>
      </div>
      <v-icon :color="seleccion === o.PrecioUnitario ? 'primary' : undefined">
        {{ seleccion === o.PrecioUnitario ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
      </v-icon>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Seleccion',
  props: {
    opciones: {
      type: Array
    }
  },
  data () {
    return {
      seleccion: null
    }
  },
  methods: {
    choose (o) {
      this.seleccion = o.PrecioUnitario
      this.$emit('onSeleccionChange', this.seleccion)
    }
  }
}
</script>
<style scoped>
.option-list {
  margin: 0 -4px;
}
.option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.option-row:last-child {
  border-bottom: none;
}
.option-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}
.option-label {
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.3;
}
.option-row--active .option-label {
  font-weight: 600;
}
.option-price {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.55);
}
</style>
